import Listar from '@/views/Pessoas/Listar'
import Form from '@/views/Pessoas/Form'

const routes = [
    {
        meta: {auth: true},
        path: '/pessoas',
        name: 'pessoas',
        component: Listar
    },
    {
        meta: {auth: true},
        path: '/pessoas/adicionar',
        name: 'pessoas.adicionar',
        component: Form
    },
    {
        meta: {auth: true},
        path: '/pessoas/editar/:id',
        name: 'pessoas.editar',
        component: Form
    },

]
export default routes
